import React from 'react'
import LiveAuctionDetail from './live-auction-detail/LiveAuctionDetail'

export const LiveAuction = () => {
  return (
    <>
      <LiveAuctionDetail/>
    </>
  )
}

export default LiveAuction;
